import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  margin-left: ${({ theme }) => `-${theme.space.lg}`};
  width: ${({ theme }) => `calc(100% + ${theme.space.xxxl})`};

  ${Col} {
    padding: 0;
  }
`
